import React, { Component } from 'react';
import ChatBotApiService from '../../../services/chatbot-api.service';
import ThirdPartyApiService from '../../../services/third-party-api.service';
import GlobalStoreService from '../../../services/global-store.service';
import $ from 'jquery';
import PlatformType from '../../../enums/PlatformType';
import IdleTimeoutService from "../../../services/idle-timeout.service";
import { globalConstants } from "../../../constants/globalConstants";

const ChatBarInputField = (props) => {
    let {setSearchSuggestions, field_type, handleUserInput, disable_field ,setInputTextState, inputBoxRef} = props;
    let recognition;
    const handleInputChange = (e) => {
        IdleTimeoutService.updateIdleState();
        let input_value = e ? e.target.value :  $('#user_input').val();;
        setInputTextState(input_value)
        if(input_value.length > 0) {
            $('#user_submit_button').addClass('active')
        }
        else{
            $('#user_submit_button').removeClass('active')
        }
        let search_suggestions= {}
        
        if (input_value.length > 2) {

            if (field_type === globalConstants.INPUT_FIELD_TYPES.CHAT ) {
                return new Promise((resolve, reject) => {
                    ChatBotApiService.getSmartSearches(input_value).then(
                        response => {
                            if(response && response.status && response.status === "UNAUTHORIZED") {
                                //HANDLING SESSION EXPIRATION
                            } else {
                                search_suggestions = response;
                                setSearchSuggestions(search_suggestions,input_value);
                            }
                            resolve();
                        },
                        (error) => {

                            // console.log(error);
                            reject();
                        });
                });
            }
            else if (field_type === globalConstants.INPUT_FIELD_TYPES.PLACE) {

                return new Promise((resolve, reject) => {

                    ChatBotApiService.getCountrySmartSearches(input_value).then(
                        res => {
                            if(res && res.status && res.status === "UNAUTHORIZED") {
                                //HANDLING SESSION EXPIRATION
                            } else {
                                res = res ? JSON.parse(res) : {}
                                let search_suggestions = [];
                                res && res.predictions && res.predictions.map(item => {
                                    search_suggestions.push(item);
                                })
                                setSearchSuggestions(search_suggestions,input_value)
                            }
                            resolve();
                        },
                        (error) => {
                            // console.log(error);
                            reject(error);
                        });
                });
            }
        }
    
        else {
            setSearchSuggestions(search_suggestions, input_value);
        }

    };

    var SpeechRecognition = window.webkitSpeechRecognition
    var SpeechGrammarList = window.webkitSpeechGrammarList 
    var SpeechRecognitionEvent = window.webkitSpeechRecognitionEvent 
    // console.log(window.webkitSpeechRecognition)
    if(SpeechRecognition){
        recognition = new SpeechRecognition();
    }
    // var speechRecognitionList = new SpeechGrammarList();

    const handleUserRecording = () => {
        if(recognition){
        recognition.start();
        $('#mic_button_id').addClass('red')
        document.getElementById('mic_button_id').disabled =  true

        }
        // this.recognition =recognition
        // console.log('Ready to listen.');
    }
    
    if(recognition){
    recognition.onresult = function(event) {
       
        var last = event.results.length - 1;
        let transcript = event.results[last][0].transcript;
        // console.log(event.results)
        // console.log('result ' + transcript);
        if(transcript){
            $('#user_input').val(transcript);
            $('#mic_button_id').removeClass('red')
            document.getElementById('mic_button_id').disabled = false
            handleInputChange();
        }
       
      }
    
      recognition.onspeechend = function() {
        recognition.stop();
        console.log('speech end')
        $('#mic_button_id').removeClass('red')
        document.getElementById('mic_button_id').disabled =  false
      }
      
      recognition.onnomatch = function(event) {
          console.log('no match')
          $('#mic_button_id').removeClass('red')
          document.getElementById('mic_button_id').disabled =  false
      }
      
      recognition.onerror = function(event) {
          console.log('error occurred',event)
          $('#mic_button_id').removeClass('red')
          document.getElementById('mic_button_id').disabled =  false
          
      }
    }
   
    return (
        <div style={{ display: 'inherit' }}>
        
            <input
                autoComplete="off"
                id="user_input"
                ref = {inputBoxRef}
                disabled={disable_field}
                type="text" width="260"
                placeholder={`Type your ${field_type === globalConstants.INPUT_FIELD_TYPES.PLACE ? 'place' : 'message'} here...`}
                onChange={(e) => handleInputChange(e)}
            />
            {/* {recognition && <button style={{border:'none'}} href="javascript:void(0)" id="mic_button_id" className="mic_button " onClick={()=>{
                handleUserRecording()
            }}/>} */}
            <a href="javascript:void(0)" id="user_submit_button" 
            className={ `chat-submit${GlobalStoreService.get('platformType')===PlatformType.WEB ? '-red' :''}` + ((field_type === globalConstants.INPUT_FIELD_TYPES.PLACE)? " cursr-not-allowed": "") } 
            onMouseDown={() => { (field_type === globalConstants.INPUT_FIELD_TYPES.CHAT)  && handleUserInput() }} />
            {/* <a href="javascript:void(0)" id="user_submit_button" 
            className={ `chat-submit${GlobalStoreService.get('platformType')===PlatformType.WEB ? '-red' :''}` + ((field_type === 'place')? " cursr-not-allowed": "") } 
            onMouseDown={() => { (field_type === 'chat')  && handleSuggestionOrInputSubmit({ type: 'submit_button' }) }} /> */}
        </div>

    );

}

export default ChatBarInputField;



// WEBPACK FOOTER //
// ./src/components/bottom-components/default-chat-bar-components/chatBarInputField.js